import {FileFragmentFragment, FileType} from "@/graphql/graphql";
import {GraphQLErrorCode} from "@/graphql/config.ts";
import toast from "react-hot-toast";
import {Button, Stack, Typography} from "@mui/material";
import {LockKeyhole} from "lucide-react";
import {Link} from "react-router-dom";

const endpointUrl = import.meta.env.VITE_APP_BACKEND_URL + "/api";

export async function uploadFile(
  file: File,
  type: FileType,
  token: string,
  zyusetuId?: string,
): Promise<FileFragmentFragment | null> {
  const formData = new FormData();
  formData.append("file", file);
  
  const urlSearchParam = new URLSearchParams({
    fileType: type,
    ...(zyusetuId ? {zyusetuId} : {}),
  }).toString();
  
  const response = await fetch(`${endpointUrl}/upload?${urlSearchParam}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  
  const result = await response.json();
  
  if (result.extensions?.code) {
    await handleApiError(result.extensions.code, result.message);
    return null;
  }
  
  if (!response.ok) {
    return null;
  }
  
  return result;
}

export async function createOrganizationApi(
  apiKey: string,
  organizationCode: string,
  organizationName: string,
  userName: string,
  email: string,
  password: string,
) {
  const response = await fetch(`${endpointUrl}/paradis/organizations`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-API-KEY": apiKey,
    },
    body: JSON.stringify({
      code: organizationCode,
      name: organizationName,
      user: {
        name: userName,
        email: email,
        password: password,
      },
    }),
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "組織の作成に失敗しました");
  }
  
}

export async function handleApiError(code: GraphQLErrorCode, message: string) {
  switch (code) {
    case GraphQLErrorCode.USAGE_LIMIT_EXCEEDED:
      toast.error(<Stack spacing={2} p={2}>
        <Typography>利用制限エラー<br/>{
          message
        }</Typography>
        <Button variant={'contained'} component={Link} to={'/contact'}>
          問い合わせる
        </Button>
      </Stack>, {
        icon: <LockKeyhole color={'red'}/>,
        duration: 20000,
      });
      break;
    case GraphQLErrorCode.INTERNAL_SERVER_ERROR:
      if (message.includes("User not found")) {
        
        return
      }
      toast.error(<Stack spacing={2} p={2}>
        <Typography>サーバーエラー<br/>しばらくしてからもう一度お試しください</Typography>
        <Button variant={'contained'} component={Link} to={'/contact'}>
          問い合わせる
        </Button>
      </Stack>, {
        icon: <LockKeyhole color={'red'}/>,
        duration: 5000,
      });
      
      break
    
    default:
      toast.error(<Stack spacing={2} p={2}>
        <Typography>{
          message
        }</Typography>
        <Button variant={'contained'} component={Link} to={'/contact'}>
          問い合わせる
        </Button>
      </Stack>, {
        icon: <LockKeyhole color={'red'}/>,
        duration: 5000,
      });
      
      return
  }
  
}
